import {defineMessages, FormattedMessage} from 'react-intl';
import {Text, Overlay} from 'src/v2/components/common';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import {useSelector} from 'src/v2/state/store';
import {WalletRegistry} from 'src/v2/util/WalletRegistry';

const messages = defineMessages({
  confirmTransaction: {
    id: 'crypto.payins.v2.payment_confirmation_pending.confirm_transaction',
    description:
      'Prompt to tell the user to confirm the transaction in the crypto wallet',
    defaultMessage: 'Review and confirm your transaction',
  },
});

export const PaymentConfirmationPendingOverlay = () => {
  const activeWallet = useSelector(
    (state) => state.walletConnection.activeWallet,
  );

  if (!activeWallet) {
    throw new Error(
      'activeWallet is required in PaymentConfirmationPendingOverlay',
    );
  }

  const walletOption = WalletRegistry.getWalletOption({
    provider: activeWallet.type,
    key: activeWallet.key,
  });

  if (!walletOption) {
    throw new Error(
      'Wallet option not found in PaymentConfirmationPendingOverlay',
    );
  }

  return (
    <Overlay name="payment-confirmation-pending">
      <WalletIcon walletOption={walletOption} />
      <Text type="title" css={{textColor: 'inherit'}}>
        <FormattedMessage {...messages.confirmTransaction} />
      </Text>
    </Overlay>
  );
};
